import { Pipe, PipeTransform } from '@angular/core';

/**
 * Transforms the given control name into a text-mask to be applied using angular2-text-mask module
 */
@Pipe({
  name: 'inputMask'
})
export class InputMaskPipe implements PipeTransform {
  transform(controlName: string): any {
    switch (controlName) {
      case 'phone_number':
      case 'fax':
      case 'send_pdf_via_fax':
        return ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
      default:
        return false;
    }
  }
}
